import React from 'react';

function SvgIcDuplicatesButton(props) {
  return (
    <svg
      id="ic_duplicate_svg__img_"
      width={149}
      height={149}
      viewBox="0 0 149 149"
      xmlSpace="preserve"
      {...props}
    >
      <defs>
        <linearGradient
          id="ic_duplicates_button_7_svg__a"
          x2={1}
          y2={1}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#f734c2" />
          <stop offset={1} stopColor="#d82121" />
        </linearGradient>
      </defs>
      <path
        data-name="Path 373"
        d="M6 0h137a6 6 0 016 6v137a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6z"
        fill="url(#ic_duplicates_button_7_svg__a)"
      />
      <g fill="#fff">
        <path
          data-name="Trazado 617"
          d="M62.542 80.864h3.053a1.527 1.527 0 011.527 1.527h3.053a4.58 4.58 0 00-4.58-4.58v-3.054h-3.053v3.053a4.58 4.58 0 100 9.16h3.053a1.527 1.527 0 010 3.053h-3.053a1.527 1.527 0 01-1.527-1.527h-3.053a4.58 4.58 0 004.58 4.58v3.053h3.053v-3.052a4.58 4.58 0 000-9.16h-3.053a1.527 1.527 0 010-3.053z"
        />
        <path
          data-name="Trazado 618"
          d="M117.503 56.436h-18.32v-22.9a4.58 4.58 0 00-4.58-4.58H33.535a4.58 4.58 0 00-4.58 4.58v82.441a4.58 4.58 0 004.579 4.579h83.969a3.053 3.053 0 003.052-3.052V59.49a3.053 3.053 0 00-3.052-3.054zm-36.641 0a3.053 3.053 0 00-3.053 3.053v16.336a16.794 16.794 0 100 19.252v13.267H32.008V40.956l3.027 5.449a7.633 7.633 0 006.673 3.927h20.834v3.334a4.58 4.58 0 103.053 0V50.33h20.834a7.634 7.634 0 006.673-3.927l3.027-5.447v15.48zm-3.053 29.008a13.74 13.74 0 11-13.74-13.74 13.74 13.74 0 0113.74 13.74zM65.596 57.963a1.527 1.527 0 11-1.527-1.527 1.527 1.527 0 011.527 1.527zM33.535 32.009h61.068a1.527 1.527 0 011.526 1.527v1.131l-5.7 10.253a4.58 4.58 0 01-4 2.356H65.596v-3.334a4.58 4.58 0 10-3.053 0v3.334H41.709a4.58 4.58 0 01-4-2.356l-5.701-10.253v-1.131a1.527 1.527 0 011.527-1.527zm29.007 7.633a1.527 1.527 0 111.527 1.527 1.527 1.527 0 01-1.527-1.527zm-29.007 77.862a1.527 1.527 0 01-1.527-1.527v-4.58h45.8v6.107zm83.968 0h-36.64V59.49h4.58v3.053h3.053V59.49h3.053v3.053h3.053V59.49h3.053v3.053h3.053V59.49h3.053v3.053h3.053V59.49h3.053v3.053h3.053V59.49h4.58z"
        />
        <path data-name="Trazado 619" d="M96.129 68.65h15.267v3.053H96.129z" />
        <path data-name="Trazado 620" d="M86.969 83.917h15.267v3.053H86.969z" />
        <path data-name="Trazado 621" d="M105.29 83.917h6.107v3.053h-6.107z" />
        <path data-name="Trazado 622" d="M86.969 90.024h15.267v3.053H86.969z" />
        <path data-name="Trazado 623" d="M105.29 90.024h6.107v3.053h-6.107z" />
        <path data-name="Trazado 624" d="M86.969 96.13h15.267v3.053H86.969z" />
        <path data-name="Trazado 625" d="M105.29 96.13h6.107v3.053h-6.107z" />
        <path
          data-name="Trazado 626"
          d="M86.969 102.237h15.267v3.053H86.969z"
        />
        <path data-name="Trazado 627" d="M105.29 102.237h6.107v3.053h-6.107z" />
        <path data-name="Trazado 628" d="M93.076 108.344h9.16v3.053h-9.16z" />
        <path data-name="Trazado 629" d="M105.29 108.344h6.107v3.053h-6.107z" />
        <path data-name="Trazado 630" d="M96.129 74.757h15.267v3.053H96.129z" />
      </g>
    </svg>
  );
}

export default SvgIcDuplicatesButton;
